import React from 'react';
import PropTypes from 'prop-types';
import styles from './Button.module.css';

const Button = ({
children,
onClick,
type = 'button',
id,
variant = 'default',
fullWidth = false,
disabled = false,
className = '',
}) => {
const buttonClasses = [
  styles.btn,
  styles[`btn${variant.charAt(0).toUpperCase() + variant.slice(1)}`],
  fullWidth ? styles.btnBlock : '',
  disabled ? styles.btnDisabled : '',
  className
].filter(Boolean).join(' ');

return (
  <button
    type={type}
    id={id}
    className={buttonClasses}
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
);
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  id: PropTypes.string,
  variant: PropTypes.string,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string
};

Button.defaultProps = {
  type: 'button',
  variant: 'default',
  fullWidth: false,
  disabled: false,
  className: ''
};

export default Button;